export default {
    name: "SourceGroupCard",
    props: {
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        linkUrl: {
            type: String,
            required: true
        },
        linkText: {
            type: String,
            required: true
        }
    },
    setup(props) {
        
        const text = props.text?.replace('{navn}', props.name)

        return {
            text
        }
    }
}